import APhoneDialField from './index.vue';

APhoneDialField.install = app => {
  app.component(APhoneDialField.name, APhoneDialField);
};

export default APhoneDialField;
